"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.FormError = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
function FormError(props) {
    var style = props.style, rest = __rest(props, ["style"]);
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, css = _a.css;
    return react_1.default.createElement("div", __assign({ className: css(classes.wrapper, style) }, rest));
}
exports.FormError = FormError;
exports.createStyles = function (theme) { return ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        color: theme.pallete.status.danger.main,
    },
    icon: {
        marginLeft: '0.25rem',
    },
}); };
//# sourceMappingURL=FormError.js.map